import { createApi, fetchBaseQuery} from "@reduxjs/toolkit/query/react";

// const rootUrl = 'http://localhost:34567/';
const rootUrl = 'https://testapi.royalarabian.com/';

export const apiSlice = createApi({
    reducerPath: 'api',
    baseQuery: fetchBaseQuery({baseUrl: rootUrl}),
    tagTypes: ['Suppliers'],
    endpoints:(builder) => ({
        getSuppliers:builder.query({
            query:()=>'/supplier/listallsuppliers',
            providesTags: ['Suppliers']
        }),
        addSupplier:builder.mutation({
            query:(supplier) => ({
                url:"/supplier/listallsuppliers",
                method:'POST',
                body:supplier
            }),
            transformResponse: res => res.sort((a,b) =>b.id - a.id),
            invalidatesTags:['Suppliers']
        }),
            updateSupplier: builder.mutation({
                query: (supplier) => ({
                    url: `/supplier/listsuppliersbyid/${supplier.id}`,
                    method: 'PATCH',
                    body: supplier
                }),
                invalidatesTags:['Suppliers']
            }),
            deleteSupplier: builder.mutation({
                query: ({ id }) => ({
                    url:`/supplier/deletesupplier/${id}`,
                    method: 'DELETE',
                    body: id
                }),
                invalidatesTags:['Suppliers']
            }),
    })
})

export const {
    useGetSuppliersQuery,
    useAddSupplierMutation,
    useUpdateSupplierMutation,
    useDeleteSupplierMutation
}=apiSlice;

